import React from 'react';
import {ReactComponent as Webinar} from "../../assets/svg/ways/webinar.svg";
import {ReactComponent as Fairs} from "../../assets/svg/ways/Fairs-&-Trade-shows.svg";
import {ReactComponent as Network} from "../../assets/svg/ways/Networking-events.svg";
import {ReactComponent as VideoConference} from "../../assets/svg/ways/Video-conferences.svg";
import {ReactComponent as Hybrid} from "../../assets/svg/ways/Hybrid-events.svg";
import {ReactComponent as Broadcast} from "../../assets/svg/ways/Broadcast-to-event.svg";
import {ReactComponent as Summit} from "../../assets/svg/ways/Summits-Forums.svg";
import {ReactComponent as Workshop} from "../../assets/svg/ways/Workshops.svg";
import {ReactComponent as OnlineClass} from "../../assets/svg/ways/Online-class.svg";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";


const WaysUse = () => {
	const { t } = useTranslation('common')
	const items = [
		{
			title:t('Webinar'),
			text:t('WebinarDes'),
			icon:Webinar,
			link:"/webinar"
		},
		{
			title:t('Exhibition'),
			text:t('ExhibitionDes'),
			icon:Fairs,
			className:"blue-item",
			link:"/fairs"
		},
		{
			title:t('NetworkEvents'),
			text:t('NetworkEventsDes'),
			icon:Network,
			className: "green-item",
			link:"/event"
		},
		{
			title:t('WebConferencing'),
			text:t('WebConferencingDes'),
			icon:VideoConference,
			className: "red-item",
			link:"/webconference"
		},
		{
			title:t('HybridInteractiveEvents'),
			text:t('HybridInteractiveEventsDes'),
			icon:Hybrid,
			className: "purple-item",
			link:"/interactive"
		}
	]
	const reverseItems = [
		{
			title:t('MeetingsSeminars'),
			text:t('MeetingsSeminarsDes'),
			icon:Summit,
			className: "blue-item",
			link:"/meeting"
		},
		{
			title:t('OnlineEducation'),
			text:t('OnlineEducationDes'),
			icon:Broadcast,
			link:"/online"
		},
		{
			title:t('TrainingEducationalWorkshops'),
			text:t('TrainingEducationalWorkshopsDes'),
			icon:Workshop,
			className: "green-item",
			link:"/workshop"
		},
		{
			title:t('OnlineClasses'),
			text:t('OnlineClassesDes'),
			icon:OnlineClass,
			className: "purple-item",
			link:"/class"
		}
	]
	return(
		<div className='ways-use-wrap'>
			<div className='ways-head'>
				<h3>{t('WaysHead')}</h3>
			</div>
			<div className='hero-btns'>
				<p>
					{t('WaysDes')}
				</p>
				<a href='https://panel.bellmeet.com'>
					<button>{t('StartFree')}</button>
				</a>
			</div>
			<div className='bellmeet-useage slider'>
				<ul className='slide-track' style={{width:(items.length * 340 * 2)}}>
					{items.map((item,key)=>{
						const Icon = item.icon
						return(
							<Link to={item.link} key={key}>
								<li className={item.className}>
									<div className='icon-svg'>
										<Icon/>
									</div>
									<h4>{item.title}</h4>
									<p>{item.text}</p>
								</li>
							</Link>
						)
					})}
					{items.map((item,key)=>{
						const Icon = item.icon
						return(
							<Link to={item.link} key={key}>
								<li key={key+'-2'} className={item.className}>
									<div className='icon-svg'>
										<Icon/>
									</div>
									<strong>{item.title}</strong>
									<p>{item.text}</p>
								</li>
							</Link>
						)
					})}
				</ul>
			</div>
			<div className='bellmeet-useage slider reverse'>
				<ul className='slide-track' style={{width:(reverseItems.length * 340 * 2)}}>
					{reverseItems.map((item,key)=>{
						const Icon = item.icon
						return(
							<Link to={item.link} key={key}>
								<li key={key} className={item.className}>
									<div className='icon-svg'>
										<Icon/>
									</div>
									<h4>{item.title}</h4>
									<p>{item.text}</p>
								</li>
							</Link>
						)
					})}
					{reverseItems.map((item,key)=>{
						const Icon = item.icon
						return(
							<Link to={item.link} key={key}>
								<li key={key+'-2'} className={item.className}>
									<div className='icon-svg'>
										<Icon/>
									</div>
									<strong>{item.title}</strong>
									<p>{item.text}</p>
								</li>
							</Link>
						)
					})}
				</ul>
			</div>
		</div>
	)
}

export default WaysUse;